"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ApprovableState = exports.ApprovableState = undefined;
(function (ApprovableState) {
    ApprovableState["PENDING"] = "PENDING";
    ApprovableState["APPROVED"] = "APPROVED";
    ApprovableState["REJECTED"] = "REJECTED";
})(ApprovableState || (exports.ApprovableState = ApprovableState = {}));
var AttachableType = exports.AttachableType = undefined;
(function (AttachableType) {
    AttachableType["ORGANISATION"] = "ORGANISATION";
    AttachableType["HUMAN"] = "HUMAN";
    AttachableType["CONTENT_CHANNEL"] = "CONTENT_CHANNEL";
    AttachableType["VIDEO_PROJECT"] = "VIDEO_PROJECT";
    AttachableType["SHOOT"] = "SHOOT";
    AttachableType["SHOOT_FOOTAGE"] = "SHOOT_FOOTAGE";
    AttachableType["VIDEO"] = "VIDEO";
    AttachableType["WORK_CONTRACT"] = "WORK_CONTRACT";
    AttachableType["CUSTOMER_CONTRACT"] = "CUSTOMER_CONTRACT";
    AttachableType["CAMPAIGN"] = "CAMPAIGN";
    AttachableType["CONTENT_GROUP"] = "CONTENT_GROUP";
    AttachableType["CONTENT_TYPE"] = "CONTENT_TYPE";
})(AttachableType || (exports.AttachableType = AttachableType = {}));
var BrandSize = exports.BrandSize = undefined;
(function (BrandSize) {
    BrandSize["tiny"] = "tiny";
    BrandSize["small"] = "small";
    BrandSize["medium"] = "medium";
    BrandSize["large"] = "large";
    BrandSize["global"] = "global";
})(BrandSize || (exports.BrandSize = BrandSize = {}));
var BrandStatus = exports.BrandStatus = undefined;
(function (BrandStatus) {
    BrandStatus["NORMAL"] = "NORMAL";
    BrandStatus["PREMIUM"] = "PREMIUM";
    BrandStatus["ELITE"] = "ELITE";
    BrandStatus["KEY_ACCOUNT"] = "KEY_ACCOUNT";
})(BrandStatus || (exports.BrandStatus = BrandStatus = {}));
var CurrencyPositionEnum = exports.CurrencyPositionEnum = undefined;
(function (CurrencyPositionEnum) {
    CurrencyPositionEnum["PREFIX"] = "PREFIX";
    CurrencyPositionEnum["POSTFIX"] = "POSTFIX";
})(CurrencyPositionEnum || (exports.CurrencyPositionEnum = CurrencyPositionEnum = {}));
var JobTemplateType = exports.JobTemplateType = undefined;
(function (JobTemplateType) {
    JobTemplateType["SHOOT"] = "SHOOT";
})(JobTemplateType || (exports.JobTemplateType = JobTemplateType = {}));
var ServiceType = exports.ServiceType = undefined;
(function (ServiceType) {
    ServiceType["CREATOR"] = "CREATOR";
    ServiceType["PRODUCER"] = "PRODUCER";
    ServiceType["EDIT"] = "EDIT";
})(ServiceType || (exports.ServiceType = ServiceType = {}));
var VideoProjectTemplateType = exports.VideoProjectTemplateType = undefined;
(function (VideoProjectTemplateType) {
    VideoProjectTemplateType["SHOOT"] = "SHOOT";
    VideoProjectTemplateType["EDIT"] = "EDIT";
    VideoProjectTemplateType["ALL"] = "ALL";
})(VideoProjectTemplateType || (exports.VideoProjectTemplateType = VideoProjectTemplateType = {}));
var Gender = exports.Gender = undefined;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
    Gender["UNSPECIFIED"] = "UNSPECIFIED";
})(Gender || (exports.Gender = Gender = {}));
var WorkflowRequestState = exports.WorkflowRequestState = undefined;
(function (WorkflowRequestState) {
    WorkflowRequestState["UNSTARTED"] = "UNSTARTED";
    WorkflowRequestState["STARTED"] = "STARTED";
    WorkflowRequestState["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    WorkflowRequestState["DISPUTED"] = "DISPUTED";
    WorkflowRequestState["COMPLETED"] = "COMPLETED";
})(WorkflowRequestState || (exports.WorkflowRequestState = WorkflowRequestState = {}));
var JobState = exports.JobState = undefined;
(function (JobState) {
    JobState["UNSTARTED"] = "UNSTARTED";
    JobState["STARTED"] = "STARTED";
    JobState["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    JobState["DISPUTED"] = "DISPUTED";
    JobState["COMPLETED"] = "COMPLETED";
})(JobState || (exports.JobState = JobState = {}));
var WorkContractApplicationState = exports.WorkContractApplicationState = undefined;
(function (WorkContractApplicationState) {
    WorkContractApplicationState["PENDING"] = "PENDING";
    WorkContractApplicationState["ACCEPTED"] = "ACCEPTED";
    WorkContractApplicationState["DECLINED"] = "DECLINED";
    WorkContractApplicationState["EXPIRED"] = "EXPIRED";
    WorkContractApplicationState["CANCELED"] = "CANCELED";
})(WorkContractApplicationState || (exports.WorkContractApplicationState = WorkContractApplicationState = {}));
var WorkContractInvitationState = exports.WorkContractInvitationState = undefined;
(function (WorkContractInvitationState) {
    WorkContractInvitationState["PENDING"] = "PENDING";
    WorkContractInvitationState["ACCEPTED"] = "ACCEPTED";
    WorkContractInvitationState["DECLINED"] = "DECLINED";
    WorkContractInvitationState["EXPIRED"] = "EXPIRED";
    WorkContractInvitationState["CANCELED"] = "CANCELED";
})(WorkContractInvitationState || (exports.WorkContractInvitationState = WorkContractInvitationState = {}));
var WorkContractState = exports.WorkContractState = undefined;
(function (WorkContractState) {
    WorkContractState["UNSTARTED"] = "UNSTARTED";
    WorkContractState["STARTED"] = "STARTED";
    WorkContractState["COMPLETED"] = "COMPLETED";
})(WorkContractState || (exports.WorkContractState = WorkContractState = {}));
var ShootWorkflowState = exports.ShootWorkflowState = undefined;
(function (ShootWorkflowState) {
    ShootWorkflowState["COMPLETED"] = "COMPLETED";
    ShootWorkflowState["READY"] = "READY";
    ShootWorkflowState["UNPLANNED"] = "UNPLANNED";
    ShootWorkflowState["PLANNING"] = "PLANNING";
})(ShootWorkflowState || (exports.ShootWorkflowState = ShootWorkflowState = {}));
var VideoWorkflowState = exports.VideoWorkflowState = undefined;
(function (VideoWorkflowState) {
    VideoWorkflowState["PLANNING"] = "PLANNING";
    VideoWorkflowState["AWAITING_SEO_DETAILS"] = "AWAITING_SEO_DETAILS";
    VideoWorkflowState["READY_FOR_PUBLISH"] = "READY_FOR_PUBLISH";
    VideoWorkflowState["READY_FOR_REVIEW"] = "READY_FOR_REVIEW";
    VideoWorkflowState["LIVE"] = "LIVE";
    VideoWorkflowState["READY_FOR_EDIT"] = "READY_FOR_EDIT";
})(VideoWorkflowState || (exports.VideoWorkflowState = VideoWorkflowState = {}));
var CreateServiceActivationType = exports.CreateServiceActivationType = undefined;
(function (CreateServiceActivationType) {
    CreateServiceActivationType["ONLINE"] = "ONLINE";
    CreateServiceActivationType["PHONE"] = "PHONE";
})(CreateServiceActivationType || (exports.CreateServiceActivationType = CreateServiceActivationType = {}));
var CreateServiceState = exports.CreateServiceState = undefined;
(function (CreateServiceState) {
    CreateServiceState["PENDING"] = "PENDING";
    CreateServiceState["APPROVED"] = "APPROVED";
    CreateServiceState["REJECTED"] = "REJECTED";
})(CreateServiceState || (exports.CreateServiceState = CreateServiceState = {}));
var CreateServiceRejectionReason = exports.CreateServiceRejectionReason = undefined;
(function (CreateServiceRejectionReason) {
    CreateServiceRejectionReason["EVIDENCE"] = "EVIDENCE";
    CreateServiceRejectionReason["QUALITY"] = "QUALITY";
})(CreateServiceRejectionReason || (exports.CreateServiceRejectionReason = CreateServiceRejectionReason = {}));
var AssetContentType = exports.AssetContentType = undefined;
(function (AssetContentType) {
    AssetContentType["ATTACHMENT"] = "ATTACHMENT";
    AssetContentType["EXTERNAL_LINK"] = "EXTERNAL_LINK";
})(AssetContentType || (exports.AssetContentType = AssetContentType = {}));
var AssetType = exports.AssetType = undefined;
(function (AssetType) {
    AssetType["WORK_EXAMPLE"] = "WORK_EXAMPLE";
    AssetType["PERSONAL_VIDEO"] = "PERSONAL_VIDEO";
})(AssetType || (exports.AssetType = AssetType = {}));
var EquipmentCategory = exports.EquipmentCategory = undefined;
(function (EquipmentCategory) {
    EquipmentCategory["CAMERA"] = "CAMERA";
    EquipmentCategory["LENSES"] = "LENSES";
    EquipmentCategory["AUDIO"] = "AUDIO";
    EquipmentCategory["LIGHTING"] = "LIGHTING";
    EquipmentCategory["TRIPODS_CRANES_AND_DOLLYS"] = "TRIPODS_CRANES_AND_DOLLYS";
    EquipmentCategory["STABILISATION"] = "STABILISATION";
    EquipmentCategory["DRONES"] = "DRONES";
    EquipmentCategory["MONITORS_AND_TELEPROMPTERS"] = "MONITORS_AND_TELEPROMPTERS";
    EquipmentCategory["EDITING_AND_ANIMATION_SOFTWARE"] = "EDITING_AND_ANIMATION_SOFTWARE";
    EquipmentCategory["GRIPS"] = "GRIPS";
    EquipmentCategory["OTHER"] = "OTHER";
})(EquipmentCategory || (exports.EquipmentCategory = EquipmentCategory = {}));
var CreatorProfileState = exports.CreatorProfileState = undefined;
(function (CreatorProfileState) {
    CreatorProfileState["PROFILE"] = "PROFILE";
    CreatorProfileState["SKILLS"] = "SKILLS";
    CreatorProfileState["ACTIVATION"] = "ACTIVATION";
    CreatorProfileState["BOOK_ACTIVATION"] = "BOOK_ACTIVATION";
    CreatorProfileState["AWAITING_ACTIVATION"] = "AWAITING_ACTIVATION";
    CreatorProfileState["COMPLETED"] = "COMPLETED";
})(CreatorProfileState || (exports.CreatorProfileState = CreatorProfileState = {}));
var RequestTicketAssigneeType = exports.RequestTicketAssigneeType = undefined;
(function (RequestTicketAssigneeType) {
    RequestTicketAssigneeType["BRAND"] = "BRAND";
    RequestTicketAssigneeType["PRODUCER"] = "PRODUCER";
    RequestTicketAssigneeType["CREATOR"] = "CREATOR";
    RequestTicketAssigneeType["JOBOWNER"] = "JOBOWNER";
})(RequestTicketAssigneeType || (exports.RequestTicketAssigneeType = RequestTicketAssigneeType = {}));
var CommentType = exports.CommentType = undefined;
(function (CommentType) {
    CommentType["COMMENT"] = "COMMENT";
    CommentType["NORMAL"] = "NORMAL";
    CommentType["RELEASE"] = "RELEASE";
    CommentType["RESOLVE"] = "RESOLVE";
    CommentType["MODERATION_REJECT"] = "MODERATION_REJECT";
})(CommentType || (exports.CommentType = CommentType = {}));
var ContentGroupType = exports.ContentGroupType = undefined;
(function (ContentGroupType) {
    ContentGroupType["SERIES"] = "SERIES";
    ContentGroupType["EVENT"] = "EVENT";
    ContentGroupType["CAMPAIGN"] = "CAMPAIGN";
    ContentGroupType["SET"] = "SET";
})(ContentGroupType || (exports.ContentGroupType = ContentGroupType = {}));
var ContentChannelType = exports.ContentChannelType = undefined;
(function (ContentChannelType) {
    ContentChannelType["BRAND"] = "BRAND";
    ContentChannelType["EVENT"] = "EVENT";
    ContentChannelType["PRODUCT"] = "PRODUCT";
    ContentChannelType["CUSTOMER"] = "CUSTOMER";
    ContentChannelType["INTERNAL_COMMS"] = "INTERNAL_COMMS";
    ContentChannelType["PEOPLE"] = "PEOPLE";
    ContentChannelType["LOCATION"] = "LOCATION";
    ContentChannelType["CAMPAIGN"] = "CAMPAIGN";
    ContentChannelType["NEWS"] = "NEWS";
    ContentChannelType["OTHER"] = "OTHER";
})(ContentChannelType || (exports.ContentChannelType = ContentChannelType = {}));
var RequestTicketLanguage = exports.RequestTicketLanguage = undefined;
(function (RequestTicketLanguage) {
    RequestTicketLanguage["ENGLISH"] = "ENGLISH";
    RequestTicketLanguage["JAPANESE"] = "JAPANESE";
})(RequestTicketLanguage || (exports.RequestTicketLanguage = RequestTicketLanguage = {}));
var RequestTicketMatchedReason = exports.RequestTicketMatchedReason = undefined;
(function (RequestTicketMatchedReason) {
    RequestTicketMatchedReason["PREFERRED"] = "PREFERRED";
    RequestTicketMatchedReason["WORKED_BEFORE"] = "WORKED_BEFORE";
    RequestTicketMatchedReason["CLOSEST"] = "CLOSEST";
})(RequestTicketMatchedReason || (exports.RequestTicketMatchedReason = RequestTicketMatchedReason = {}));
var RequestTicketRequesterType = exports.RequestTicketRequesterType = undefined;
(function (RequestTicketRequesterType) {
    RequestTicketRequesterType["GEN1_BOT"] = "GEN1_BOT";
    RequestTicketRequesterType["BOT"] = "BOT";
    RequestTicketRequesterType["BRAND"] = "BRAND";
    RequestTicketRequesterType["PRODUCER"] = "PRODUCER";
    RequestTicketRequesterType["CREATOR"] = "CREATOR";
})(RequestTicketRequesterType || (exports.RequestTicketRequesterType = RequestTicketRequesterType = {}));
var RequestTicketState = exports.RequestTicketState = undefined;
(function (RequestTicketState) {
    RequestTicketState["UNASSIGNED"] = "UNASSIGNED";
    RequestTicketState["ASSIGNED"] = "ASSIGNED";
    RequestTicketState["ACTIVE"] = "ACTIVE";
    RequestTicketState["SCHEDULED"] = "SCHEDULED";
    RequestTicketState["CANCELLED"] = "CANCELLED";
    RequestTicketState["RESOLVED"] = "RESOLVED";
    RequestTicketState["MODERATION_CLAIMED"] = "MODERATION_CLAIMED";
    RequestTicketState["MODERATION_APPROVED"] = "MODERATION_APPROVED";
})(RequestTicketState || (exports.RequestTicketState = RequestTicketState = {}));
var RequestTicketUrgency = exports.RequestTicketUrgency = undefined;
(function (RequestTicketUrgency) {
    RequestTicketUrgency["NOT_URGENT"] = "NOT_URGENT";
    RequestTicketUrgency["ASAP"] = "ASAP";
    RequestTicketUrgency["URGENT"] = "URGENT";
})(RequestTicketUrgency || (exports.RequestTicketUrgency = RequestTicketUrgency = {}));
var ProducerStatus = exports.ProducerStatus = undefined;
(function (ProducerStatus) {
    ProducerStatus["ONLINE"] = "ONLINE";
    ProducerStatus["OFFLINE"] = "OFFLINE";
    ProducerStatus["PREFERRED_ONLY"] = "PREFERRED_ONLY";
})(ProducerStatus || (exports.ProducerStatus = ProducerStatus = {}));
var ProductActivationStateType = exports.ProductActivationStateType = undefined;
(function (ProductActivationStateType) {
    ProductActivationStateType["DRAFT"] = "DRAFT";
    ProductActivationStateType["ACTIVE"] = "ACTIVE";
    ProductActivationStateType["ARCHIVED"] = "ARCHIVED";
})(ProductActivationStateType || (exports.ProductActivationStateType = ProductActivationStateType = {}));
var ProjectState = exports.ProjectState = undefined;
(function (ProjectState) {
    ProjectState["PURCHASING"] = "PURCHASING";
    ProjectState["ACTIVE"] = "ACTIVE";
    ProjectState["COMPLETED"] = "COMPLETED";
    ProjectState["LOST"] = "LOST";
})(ProjectState || (exports.ProjectState = ProjectState = {}));
var AttachmentState = exports.AttachmentState = undefined;
(function (AttachmentState) {
    AttachmentState["UPLOADING"] = "UPLOADING";
    AttachmentState["SYNCING"] = "SYNCING";
    AttachmentState["COMPLETED"] = "COMPLETED";
    AttachmentState["FAILED"] = "FAILED";
})(AttachmentState || (exports.AttachmentState = AttachmentState = {}));
var AttachmentType = exports.AttachmentType = undefined;
(function (AttachmentType) {
    AttachmentType["CONTRACT"] = "CONTRACT";
    AttachmentType["BRIEF"] = "BRIEF";
    AttachmentType["BRAND_ASSET"] = "BRAND_ASSET";
    AttachmentType["LOGO"] = "LOGO";
    AttachmentType["INTRO_OUTRO"] = "INTRO_OUTRO";
    AttachmentType["ANIMATION"] = "ANIMATION";
    AttachmentType["GRAPHIC"] = "GRAPHIC";
    AttachmentType["THUMBNAIL"] = "THUMBNAIL";
    AttachmentType["HERO_IMAGE"] = "HERO_IMAGE";
    AttachmentType["PHOTO"] = "PHOTO";
    AttachmentType["PHOTO_FROM_VIDEO"] = "PHOTO_FROM_VIDEO";
    AttachmentType["FOOTAGE"] = "FOOTAGE";
    AttachmentType["FOOTAGE_MOBILE"] = "FOOTAGE_MOBILE";
    AttachmentType["MUSIC"] = "MUSIC";
    AttachmentType["AUDIO_TRACK"] = "AUDIO_TRACK";
    AttachmentType["DRAFT_VIDEO"] = "DRAFT_VIDEO";
    AttachmentType["FINAL_VIDEO"] = "FINAL_VIDEO";
    AttachmentType["TRANSCODED"] = "TRANSCODED";
    AttachmentType["SUMMARY"] = "SUMMARY";
    AttachmentType["WATERMARKED"] = "WATERMARKED";
    AttachmentType["OTHER"] = "OTHER";
})(AttachmentType || (exports.AttachmentType = AttachmentType = {}));
var ContentManagerAssetType = exports.ContentManagerAssetType = undefined;
(function (ContentManagerAssetType) {
    ContentManagerAssetType["ANIMATION"] = "ANIMATION";
    ContentManagerAssetType["AUDIO"] = "AUDIO";
    ContentManagerAssetType["MUSIC"] = "MUSIC";
    ContentManagerAssetType["BRAND_ASSETS"] = "BRAND_ASSETS";
    ContentManagerAssetType["FOOTAGE"] = "FOOTAGE";
    ContentManagerAssetType["GRAPHIC"] = "GRAPHIC";
    ContentManagerAssetType["OTHERS"] = "OTHERS";
    ContentManagerAssetType["PHOTO"] = "PHOTO";
    ContentManagerAssetType["VIDEO"] = "VIDEO";
})(ContentManagerAssetType || (exports.ContentManagerAssetType = ContentManagerAssetType = {}));
var UserState = exports.UserState = undefined;
(function (UserState) {
    UserState["CONFIRMED"] = "CONFIRMED";
    UserState["UNCONFIRMED"] = "UNCONFIRMED";
    UserState["LOCKED"] = "LOCKED";
})(UserState || (exports.UserState = UserState = {}));
var OrderDirection = exports.OrderDirection = undefined;
(function (OrderDirection) {
    OrderDirection["ASC"] = "ASC";
    OrderDirection["DESC"] = "DESC";
})(OrderDirection || (exports.OrderDirection = OrderDirection = {}));
var UserOrder = exports.UserOrder = undefined;
(function (UserOrder) {
    UserOrder["CREATED_AT"] = "CREATED_AT";
    UserOrder["EMAIL"] = "EMAIL";
    UserOrder["NAME"] = "NAME";
})(UserOrder || (exports.UserOrder = UserOrder = {}));
var JobOrder = exports.JobOrder = undefined;
(function (JobOrder) {
    JobOrder["START_DATE"] = "START_DATE";
    JobOrder["DUE_DATE"] = "DUE_DATE";
    JobOrder["COMPLETED_AT"] = "COMPLETED_AT";
})(JobOrder || (exports.JobOrder = JobOrder = {}));
var OpportunityState = exports.OpportunityState = undefined;
(function (OpportunityState) {
    OpportunityState["PROSPECTIVE"] = "PROSPECTIVE";
    OpportunityState["IN_PROGRESS"] = "IN_PROGRESS";
    OpportunityState["CONVERTED"] = "CONVERTED";
    OpportunityState["LOST"] = "LOST";
})(OpportunityState || (exports.OpportunityState = OpportunityState = {}));
var OpportunitySourceType = exports.OpportunitySourceType = undefined;
(function (OpportunitySourceType) {
    OpportunitySourceType["PLATFORM"] = "PLATFORM";
    OpportunitySourceType["SALESFORCE"] = "SALESFORCE";
})(OpportunitySourceType || (exports.OpportunitySourceType = OpportunitySourceType = {}));
var OpportunityPriority = exports.OpportunityPriority = undefined;
(function (OpportunityPriority) {
    OpportunityPriority["SAME_DAY"] = "SAME_DAY";
    OpportunityPriority["URGENT"] = "URGENT";
    OpportunityPriority["NOT_URGENT"] = "NOT_URGENT";
})(OpportunityPriority || (exports.OpportunityPriority = OpportunityPriority = {}));
var RequestTicketTargetType = exports.RequestTicketTargetType = undefined;
(function (RequestTicketTargetType) {
    RequestTicketTargetType["GEN1_PROJECT"] = "GEN1_PROJECT";
    RequestTicketTargetType["GEN1_SHOOT"] = "GEN1_SHOOT";
    RequestTicketTargetType["GEN1_VIDEO"] = "GEN1_VIDEO";
    RequestTicketTargetType["OTHER"] = "OTHER";
    RequestTicketTargetType["VIDEO_PROJECT"] = "VIDEO_PROJECT";
    RequestTicketTargetType["WORK_CONTRACT"] = "WORK_CONTRACT";
    RequestTicketTargetType["JOB"] = "JOB";
    RequestTicketTargetType["SHOOT"] = "SHOOT";
    RequestTicketTargetType["VIDEO"] = "VIDEO";
})(RequestTicketTargetType || (exports.RequestTicketTargetType = RequestTicketTargetType = {}));
var RequestTicketOrder = exports.RequestTicketOrder = undefined;
(function (RequestTicketOrder) {
    RequestTicketOrder["CREATED_AT"] = "CREATED_AT";
    RequestTicketOrder["URGENCY"] = "URGENCY";
    RequestTicketOrder["SCHEDULED_FOR"] = "SCHEDULED_FOR";
})(RequestTicketOrder || (exports.RequestTicketOrder = RequestTicketOrder = {}));
var FeedableType = exports.FeedableType = undefined;
(function (FeedableType) {
    FeedableType["ORGANISATION"] = "ORGANISATION";
    FeedableType["HUMAN"] = "HUMAN";
    FeedableType["PROJECT"] = "PROJECT";
    FeedableType["VIDEO"] = "VIDEO";
    FeedableType["SHOOT"] = "SHOOT";
    FeedableType["JOB"] = "JOB";
    FeedableType["WORK_CONTRACT"] = "WORK_CONTRACT";
    FeedableType["CUSTOMER_CONTRACT"] = "CUSTOMER_CONTRACT";
    FeedableType["CAMPAIGN"] = "CAMPAIGN";
    FeedableType["ISSUE"] = "ISSUE";
    FeedableType["CONTENT_CHANNEL"] = "CONTENT_CHANNEL";
    FeedableType["CONTENT_GROUP"] = "CONTENT_GROUP";
})(FeedableType || (exports.FeedableType = FeedableType = {}));
var FeedCommentType = exports.FeedCommentType = undefined;
(function (FeedCommentType) {
    FeedCommentType["COMMENT"] = "COMMENT";
    FeedCommentType["EMAIL"] = "EMAIL";
    FeedCommentType["MEETING"] = "MEETING";
    FeedCommentType["NOTE"] = "NOTE";
    FeedCommentType["PHONE_CALL"] = "PHONE_CALL";
    FeedCommentType["PROPOSAL"] = "PROPOSAL";
})(FeedCommentType || (exports.FeedCommentType = FeedCommentType = {}));
var IssueState = exports.IssueState = undefined;
(function (IssueState) {
    IssueState["NEW"] = "NEW";
    IssueState["IN_REVIEW"] = "IN_REVIEW";
    IssueState["IN_PROGRESS"] = "IN_PROGRESS";
    IssueState["ESCALATED"] = "ESCALATED";
    IssueState["RESOLVED"] = "RESOLVED";
    IssueState["ACCEPTED"] = "ACCEPTED";
    IssueState["NOT_RESOLVED"] = "NOT_RESOLVED";
})(IssueState || (exports.IssueState = IssueState = {}));
var StripeChargeStatus = exports.StripeChargeStatus = undefined;
(function (StripeChargeStatus) {
    StripeChargeStatus["PENDING"] = "PENDING";
    StripeChargeStatus["SUCCESS"] = "SUCCESS";
    StripeChargeStatus["FAILED"] = "FAILED";
    StripeChargeStatus["REFUNDED"] = "REFUNDED";
})(StripeChargeStatus || (exports.StripeChargeStatus = StripeChargeStatus = {}));
var CommentableType = exports.CommentableType = undefined;
(function (CommentableType) {
    CommentableType["REQUEST_TICKET"] = "REQUEST_TICKET";
    CommentableType["ORGANISATION"] = "ORGANISATION";
    CommentableType["HUMAN"] = "HUMAN";
    CommentableType["PROJECT"] = "PROJECT";
    CommentableType["VIDEO"] = "VIDEO";
    CommentableType["JOB"] = "JOB";
    CommentableType["WORK_CONTRACT"] = "WORK_CONTRACT";
    CommentableType["CUSTOMER_CONTRACT"] = "CUSTOMER_CONTRACT";
    CommentableType["CAMPAIGN"] = "CAMPAIGN";
    CommentableType["SHOOT"] = "SHOOT";
    CommentableType["ISSUE"] = "ISSUE";
    CommentableType["CONTENT_CHANNEL"] = "CONTENT_CHANNEL";
    CommentableType["CONTENT_GROUP"] = "CONTENT_GROUP";
})(CommentableType || (exports.CommentableType = CommentableType = {}));
var EventableType = exports.EventableType = undefined;
(function (EventableType) {
    EventableType["PROJECT"] = "PROJECT";
    EventableType["VIDEO"] = "VIDEO";
    EventableType["JOB"] = "JOB";
    EventableType["WORK_CONTRACT"] = "WORK_CONTRACT";
    EventableType["CUSTOMER_CONTRACT"] = "CUSTOMER_CONTRACT";
    EventableType["SHOOT"] = "SHOOT";
    EventableType["ISSUE"] = "ISSUE";
})(EventableType || (exports.EventableType = EventableType = {}));
var NotifiableType = exports.NotifiableType = undefined;
(function (NotifiableType) {
    NotifiableType["REQUEST_COMMENT"] = "REQUEST_COMMENT";
    NotifiableType["FEED_ITEM"] = "FEED_ITEM";
    NotifiableType["JOB"] = "JOB";
    NotifiableType["WORK_CONTRACT"] = "WORK_CONTRACT";
    NotifiableType["WORK_CONTRACT_APPLICATION"] = "WORK_CONTRACT_APPLICATION";
    NotifiableType["WORK_CONTRACT_INVITATION"] = "WORK_CONTRACT_INVITATION";
})(NotifiableType || (exports.NotifiableType = NotifiableType = {}));
var NotificationAction = exports.NotificationAction = undefined;
(function (NotificationAction) {
    NotificationAction["CREATED"] = "CREATED";
    NotificationAction["UPDATED"] = "UPDATED";
    NotificationAction["ACCEPTED"] = "ACCEPTED";
    NotificationAction["DECLINED"] = "DECLINED";
    NotificationAction["CANCELED"] = "CANCELED";
    NotificationAction["ASSIGNED"] = "ASSIGNED";
    NotificationAction["RESOLVED"] = "RESOLVED";
    NotificationAction["UNASSIGNED"] = "UNASSIGNED";
    NotificationAction["SKILLS_APPROVED"] = "SKILLS_APPROVED";
    NotificationAction["SKILLS_REJECTED"] = "SKILLS_REJECTED";
    NotificationAction["TICKET_COMMENT"] = "TICKET_COMMENT";
    NotificationAction["CLAIMED"] = "CLAIMED";
    NotificationAction["DUE"] = "DUE";
})(NotificationAction || (exports.NotificationAction = NotificationAction = {}));
var RequestTicketTypeName = exports.RequestTicketTypeName = undefined;
(function (RequestTicketTypeName) {
    RequestTicketTypeName["CHANGE"] = "CHANGE";
    RequestTicketTypeName["TALK"] = "TALK";
    RequestTicketTypeName["UPDATE"] = "UPDATE";
    RequestTicketTypeName["OTHER"] = "OTHER";
    RequestTicketTypeName["ISSUE"] = "ISSUE";
    RequestTicketTypeName["SOMETHING_ELSE"] = "SOMETHING_ELSE";
})(RequestTicketTypeName || (exports.RequestTicketTypeName = RequestTicketTypeName = {}));
var DeviceType = exports.DeviceType = undefined;
(function (DeviceType) {
    DeviceType["IOS"] = "IOS";
    DeviceType["ANDROID"] = "ANDROID";
})(DeviceType || (exports.DeviceType = DeviceType = {}));
var VideoPlatformIntegrationProvider = exports.VideoPlatformIntegrationProvider = undefined;
(function (VideoPlatformIntegrationProvider) {
    VideoPlatformIntegrationProvider["YOUTUBE"] = "YOUTUBE";
    VideoPlatformIntegrationProvider["VIMEO"] = "VIMEO";
})(VideoPlatformIntegrationProvider || (exports.VideoPlatformIntegrationProvider = VideoPlatformIntegrationProvider = {}));
var OpportunityProducerRole = exports.OpportunityProducerRole = undefined;
(function (OpportunityProducerRole) {
    OpportunityProducerRole["CONTENT"] = "CONTENT";
    OpportunityProducerRole["CREATIVE"] = "CREATIVE";
})(OpportunityProducerRole || (exports.OpportunityProducerRole = OpportunityProducerRole = {}));
var IdentityProvider = exports.IdentityProvider = undefined;
(function (IdentityProvider) {
    IdentityProvider["FACEBOOK"] = "FACEBOOK";
    IdentityProvider["LINKEDIN_SDK"] = "LINKEDIN_SDK";
    IdentityProvider["LINKEDIN_OAUTH2"] = "LINKEDIN_OAUTH2";
    IdentityProvider["LINKEDIN_OAUTH2_ACCESS_TOKEN"] = "LINKEDIN_OAUTH2_ACCESS_TOKEN";
})(IdentityProvider || (exports.IdentityProvider = IdentityProvider = {}));
var ApprovableType = exports.ApprovableType = undefined;
(function (ApprovableType) {
    ApprovableType["VIDEO"] = "VIDEO";
    ApprovableType["ATTACHMENT"] = "ATTACHMENT";
})(ApprovableType || (exports.ApprovableType = ApprovableType = {}));
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/typings/types.js
// module id = 1345
// module chunks = 0